import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useReviewsContext } from "../context/reviews.context";
import { CreateReview } from "../createReview/createReview.container";
import { Reviews } from "../reviews/reviews.container";
import { ReviewsSummary } from "../reviewsSummary/reviewsSummary.container";

export const ProductReviewsComponent = () => {
    const { reviewsSummary } = useReviewsContext();

    if (isDefined(reviewsSummary) && reviewsSummary?.summary.count > 0) {
        return (
            <article
                className={cn(
                    "tw:flex tw:relative tw:flex-col tw:gap-12",
                    "tw:xl:flex-row"
                )}
            >
                <div
                    className={cn(
                        "tw:w-full",
                        "tw:xl:min-w-80 tw:xl:max-w-80 tw:xl:sticky tw:xl:top-0 tw:xl:left-0 tw:xl:h-fit"
                    )}
                >
                    <ReviewsSummary reviewsSummary={reviewsSummary} />
                </div>
                <div className={cn("tw:w-full")}>
                    <Reviews />
                </div>
            </article>
        );
    } else {
        return (
            <article>
                <CreateReview />
            </article>
        );
    }
};
